import React, { useEffect, useRef, useState } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

const DEFAULT_LIMIT = 500;
const EDITOR_MODULES = {
  toolbar: [
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],
  ],
};
const EDITOR_FORMATS = ["bold", "italic", "underline", "strike", "list", "link"];

const escapeHtml = (value) => value
  .replace(/&/g, "&amp;")
  .replace(/</g, "&lt;")
  .replace(/>/g, "&gt;")
  .replace(/\"/g, "&quot;")
  .replace(/'/g, "&#39;");

const toEditorHtml = (value = "") => {
  if (!value) return "";
  return value
    .split(/\r?\n/)
    .map((line) => `<p>${line ? escapeHtml(line) : "<br>"}</p>`)
    .join("");
};

const SurveyDescriptionEditor = ({
  value = "",
  onChange,
  limit = DEFAULT_LIMIT,
  placeholder = "Tell participants what this survey is about.",
}) => {
  const normalizedValue = typeof value === "string" ? value : "";
  const editorRef = useRef(null);
  const lastTextRef = useRef(normalizedValue);
  const [html, setHtml] = useState(() => toEditorHtml(normalizedValue));
  const [textLength, setTextLength] = useState(normalizedValue.length);

  useEffect(() => {
    if (normalizedValue === lastTextRef.current) return;
    lastTextRef.current = normalizedValue;
    setHtml(toEditorHtml(normalizedValue));
    setTextLength(normalizedValue.length);
  }, [normalizedValue]);

  const handleChange = (content, _delta, _source, editor) => {
    const quill = editorRef.current?.getEditor();
    let text = editor.getText().replace(/\n$/, "");

    if (text.length > limit && quill) {
      quill.deleteText(limit, text.length - limit, "silent");
      text = quill.getText().replace(/\n$/, "");
      content = quill.root.innerHTML;
    }

    lastTextRef.current = text;
    setHtml(content === "<p><br></p>" ? "" : content);
    setTextLength(text.length);
    onChange(text);
  };

  return (
    <>
      <div className="cs-rich-editor survey-description-editor">
        <ReactQuill
          ref={editorRef}
          theme="snow"
          value={html}
          onChange={handleChange}
          modules={EDITOR_MODULES}
          formats={EDITOR_FORMATS}
          placeholder={placeholder}
          className="cs-rich-editor-content"
          aria-label="Survey description"
        />
      </div>
      <div className="cs-count">{textLength}/{limit}</div>
    </>
  );
};

export default SurveyDescriptionEditor;
